import { render, staticRenderFns } from "./tabsIndex.vue?vue&type=template&id=4379e0e8&scoped=true"
import script from "./tabsIndex.vue?vue&type=script&lang=js"
export * from "./tabsIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4379e0e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4379e0e8')) {
      api.createRecord('4379e0e8', component.options)
    } else {
      api.reload('4379e0e8', component.options)
    }
    module.hot.accept("./tabsIndex.vue?vue&type=template&id=4379e0e8&scoped=true", function () {
      api.rerender('4379e0e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orderCenter/expressAndlargOrder/tabsIndex.vue"
export default component.exports